/* eslint-disable  */
import { getCookie } from '../utils/cookie.js'
let isReady = false
const beforeReadyCall = []
try {
  wx.ready(function () {
    isReady = true
    console.log(`===================wechat is ready: ${isReady}===================`)
    if (beforeReadyCall.length > 0) {
      for (let i = 0;i < beforeReadyCall.length;i++) {
        beforeReadyCall[i]()
      }
    }
  })
  wx.error(function (err) {
    console.log('wechat error', err)
  })
} catch (error) {
  
}

export function wxShare(shareAppConfig, shareTimelineConfig) {
  let href = location.protocol + '//' + location.host + '/?share_id=' + getCookie('uid') + '&anchor=' + location.hash.substring(1)
  console.log(href, isReady)
  if (isReady) {
    wxShareFunc(shareAppConfig, shareTimelineConfig)
  } else {
    beforeReadyCall.push(function () {
      wxShareFunc(shareAppConfig, shareTimelineConfig)
    })
  }
}

function wxShareFunc(shareAppConfig, shareTimelineConfig) {

  // 第一个参数朋友分享参数 第二个分享到朋友圈参数
  wx.updateTimelineShareData(Object.assign({
    title: 'golo维修课堂|' + document.title, // 分享标题
    link: buildHref(), // 分享链接
    desc: document.title, // 分享描述
    imgUrl: 'https://sns.goloiov.cn/static/img/share_logo.png'
  }, shareTimelineConfig))
  wx.updateAppMessageShareData(Object.assign({
    title: 'golo维修课堂', // 分享标题
    desc: document.title, // 分享描述
    link: buildHref(), // 分享链接
    imgUrl: 'https://sns.goloiov.cn/static/img/share_logo.png'
  }, shareAppConfig))
}

export function buildHref() {
  let href = location.protocol + '//' + location.host + '/?share_id=' + getCookie('uid') + '#' + location.hash.substring(1)
  console.log(href)
  return href
}

// 当前页面的url 不带其他参数
export function currentHref() {
  return location.protocol + '//' + location.host + '/?anchor=' + location.hash.substring(1)
}

// 助力分享描述
export function zhuliShareConfig(count) {
  return {
    title: '【golo课堂】点这里！还差' + count + '人，就能帮我开通免费学习的机会',
    desc: '这里的汽修课程全是实战干货，我正在免费学习，邀请你也加入~'
  }
}

// 转盘活动分享
export function rotateShare() {
  let config = {
    title: ' golo汽修课堂每月会员福利',
    desc: '12-14日专属会员日，丰富奖品等你来抽',
    link: buildHref(),
    imgUrl: 'https://staticapp.goloiov.com/static_kingchallenge/img/draw.png'
  }
  wxShare(config, config)
}



// WEBPACK FOOTER //
// ./src/api/wx-share.js